(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["core"] = factory();
	else
		root["cps"] = root["cps"] || {}, root["cps"]["it"] = root["cps"]["it"] || {}, root["cps"]["it"]["ui"] = root["cps"]["it"]["ui"] || {}, root["cps"]["it"]["ui"]["core"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition